import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { APIResponse } from '@shared/models/auth.interface';
import { AppService } from './app.service';

import { LogPublishersConfig } from '@shared/models/app-settings.inteface';
import { ConsoleLog, LocalStorageLog, WebAPILog } from '@core/classes';
import { LogPublisher } from '@shared/models/log.interface';

@Injectable({
  providedIn: 'root'
})
export class LogPublisherService {
  pushLogAPIEndpoint: string = '';
  publishers: Array<LogPublisher> = [];
  logPublishersConfig: LogPublishersConfig = {
    console: true,
    localStorage: false,
    webAPI: false
  };

  constructor(private httpBackend: HttpBackend, private appService: AppService) {
    this.pushLogAPIEndpoint = this.appService.getAppConfigs()["LOG"].BaseUrl + this.appService.getAppConfigs()["LOG"].Versions.V1["CLIENTLOGS"]["PostClientLogs"].PATH;
    this.logPublishersConfig = this.appService.getAppSettings().log.logPublishersConfig || this.logPublishersConfig;
    this.buildPublishers();
  }

  buildPublishers(): void {
    if (this.logPublishersConfig.console) this.publishers.push(new ConsoleLog());
    if (this.logPublishersConfig.localStorage) this.publishers.push(new LocalStorageLog());
    if (this.logPublishersConfig.webAPI) this.publishers.push(new WebAPILog<APIResponse<boolean>>(this.pushLogAPIEndpoint, this.httpBackend));
  }
}
